import { VehicleDetailsComponent } from './vehicle-details/vehicle-details.component';
import { VehicleScheduleComponent } from './vehicle-schedule/vehicle-schedule.component';
import { VehicleScheduleEditModalComponent } from './vehicle-schedule-edit-modal/vehicle-schedule-edit-modal.component';
import { VehicleScheduleSaveModalComponent } from './vehicle-schedule-save-modal/vehicle-schedule-save-modal.component';
import { VehicleTimelineConfigComponent } from './vehicle-timeline-config/vehicle-timeline-config.component';
import { VehicleSearchBarComponent } from './vehicle-search-bar/vehicle-search-bar.component';

export {
  VehicleDetailsComponent,
  VehicleScheduleComponent,
  VehicleScheduleEditModalComponent,
  VehicleScheduleSaveModalComponent,
  VehicleTimelineConfigComponent,
  VehicleSearchBarComponent,
};

export const vehicleComponents = [
  VehicleDetailsComponent,
  VehicleScheduleComponent,
  VehicleScheduleEditModalComponent,
  VehicleTimelineConfigComponent,
  VehicleSearchBarComponent,
];
